module.exports = __webpack_public_path__ + "img/icon-1.215e95d4.png";